import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const FullScreenLoader: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress size={60} thickness={4} />
    </Box>
  );
};

export default FullScreenLoader;
